const FIGMA_URL =
  'https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FcWGuo1gVCAM3Q9HNobCimN%2FKPI%3Fpage-id%3D0%253A1%26node-id%3D2%253A1%26viewport%3D173%252C-216%252C0.5535075068473816%26scaling%3Dcontain%26hotspot-hints%3D0';

export const KPIContainer = () => (
  <iframe style={{ border: 'none', height: '100vh', width: '100vw' }} allowFullScreen src={FIGMA_URL}></iframe>
);
